import type { FC } from 'react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import TestimonialSlider from '@segment/templates/TestimonialSlider'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import { testimonialData } from './data'

const copy = {
  heading: `Twilio Segment powers the world’s leading brands`,
  description: `From startups to global enterprises, see what businesses have achieved with the Twilio Segment customer data platform.`,
  button: {
    text: `View more customer stories`,
    href: `/customers/`,
  },
}

const TestimonialsSlider: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <AppearanceProvider appearance="twilioDark">
          <TestimonialSlider data={testimonialData} innerStyles={false} title={false} />
        </AppearanceProvider>

        <ButtonWrapper>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            href={getAbsoluteUrl(`${copy.button.href}`, pageConfig)}
          >
            {copy.button.text}
          </Button>
        </ButtonWrapper>
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  max-width: 1200px;
  overflow-x: visible;
`

const ButtonWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-top: 20px;
  }
`

export default TestimonialsSlider
